import { render, staticRenderFns } from "./SopBoard.vue?vue&type=template&id=0a3337f4&"
import script from "./SopBoard.vue?vue&type=script&lang=js&"
export * from "./SopBoard.vue?vue&type=script&lang=js&"
import style0 from "./SopBoard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a3337f4')) {
      api.createRecord('0a3337f4', component.options)
    } else {
      api.reload('0a3337f4', component.options)
    }
    module.hot.accept("./SopBoard.vue?vue&type=template&id=0a3337f4&", function () {
      api.rerender('0a3337f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/SopBoard.vue"
export default component.exports